import React, { useContext } from 'react';
import Header from '../../template/Header';
import { Breadcrumbs, Button, Card, CardActions, CardContent, CardHeader, Typography } from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import AppContext from '../../state/AppContext';
import UserContext from '../../state/UserContext';

const Welcome = () => {

    const { appContext } = useContext(AppContext)
    const { user } = useContext(UserContext)

    return (
        <div className="">
            <Header title="Welcome"  >
                <Breadcrumbs aria-label="breadcrumb" separator="/" className="!text-gray-600" >
                    <Typography ><HomeOutlinedIcon className="text-gray-600" fontSize="small" /></Typography>
                    <Typography ><span className="text-gray-600">Getting started</span></Typography>
                </Breadcrumbs>
            </Header>
            <div className="content grid gap-8">
                <div className="layout grid gap-8">
                    <div className="">
                        <h4 className="capitalize">Welcome {user.name.split(' ')[0]} 👋</h4>
                        <p className="text-gray-600 text-md">Below you will find some reference guides to get started with gobabk.</p>
                    </div>

                    <div className="grid grid-cols-4 gap-4">
                        <div>
                            <Card className="">
                                <CardHeader title="Getting started" className="bg-green-500" />
                                <CardContent>
                                    <p className="text-justify text-sm">This guide will help you take your first steps: from installation and initial setup to the basic actions you need to start using the tool quickly and easily, with no prior knowledge required. Perfect for anyone who wants to get up and running in just a few minutes.</p>
                                </CardContent>
                                <CardActions className='justify-end bg-gray-100'>
                                    <Button size="small">Learn More</Button>
                                </CardActions>
                            </Card>
                        </div>

                        <div>
                            <Card>
                                <CardHeader title="Rules configuration" className="bg-green-500" />
                                <CardContent>
                                <p className="text-justify text-sm">This guide will show you how to create and customize alert rules to detect movements or events of interest. You’ll learn how to set specific conditions, define thresholds, and configure notifications to ensure you receive timely alerts about what truly matters. Perfect for staying on top of critical developments.</p>
                            </CardContent>
                            <CardActions className='justify-end bg-gray-100'>
                                <Button size="small">Learn More</Button>
                                </CardActions>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Welcome;


